import * as React from "react";
import Svg, {
  Circle,
  Path,
  Defs,
  LinearGradient,
  Stop,
} from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={40}
      height={40}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Circle cx={20} cy={20} r={19.5} fill="#F5F8FF" stroke="#4274EA" />
      <Path
        d="M26.392 22.27c-.959 0-1.9-.15-2.79-.444-.445-.151-1.092.114-1.24.262-.404.399-1.545 1.54-1.545 1.54a11.661 11.661 0 01-4.79-4.805s1.1-1.108 1.493-1.491c.248-.244.455-.823.31-1.282a8.898 8.898 0 01-.445-2.795c0-.692-.564-1.255-1.256-1.255h-2.874c-.692 0-1.255.563-1.255 1.255 0 7.936 6.456 14.392 14.392 14.392.692 0 1.255-.563 1.255-1.255v-2.866c0-.692-.563-1.256-1.255-1.256z"
        fill="#2F63DE"
      />
      <Path
        opacity={0.2}
        d="M26.392 22.271c-.959 0-1.899-.15-2.79-.444-.424-.146-.896-.04-1.264.28l-3.435 3.435.01.006 3.3-3.224c.375-.32.86-.425 1.293-.28a9.29 9.29 0 002.856.444c.709 0 1.285.564 1.285 1.256v-.217c0-.693-.563-1.256-1.255-1.256z"
        fill="#fff"
      />
      <Path
        d="M20.817 23.627a11.66 11.66 0 01-4.79-4.805l-1.909 1.909a14.475 14.475 0 004.798 4.797l1.901-1.901z"
        fill="url(#paint0_linear_8231_2995)"
      />
      <Path
        opacity={0.1}
        d="M26.453 27.429a14.548 14.548 0 01-13.835-10.003 14 14 0 00.676 1.778c2.268 4.975 7.284 8.442 13.098 8.442.593 0 1.088-.414 1.22-.968-.198.441-.642.75-1.16.75z"
        fill="#010101"
      />
      <Path
        d="M26.392 22.27c-.959 0-1.9-.15-2.79-.444-.445-.151-1.092.114-1.24.262-.404.399-1.545 1.54-1.545 1.54a11.661 11.661 0 01-4.79-4.805s1.1-1.108 1.493-1.491c.248-.244.455-.823.31-1.282a8.898 8.898 0 01-.445-2.795c0-.692-.564-1.255-1.256-1.255h-2.874c-.692 0-1.255.563-1.255 1.255 0 7.936 6.456 14.392 14.392 14.392.692 0 1.255-.563 1.255-1.255v-2.866c0-.692-.563-1.256-1.255-1.256z"
        fill="url(#paint1_linear_8231_2995)"
      />
      <Defs>
        <LinearGradient
          id="paint0_linear_8231_2995"
          x1={15.1836}
          y1={20.1729}
          x2={18.9814}
          y2={23.9708}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#010101" stopOpacity={0.1} />
          <Stop offset={1} stopColor="#010101" stopOpacity={0} />
        </LinearGradient>
        <LinearGradient
          id="paint1_linear_8231_2995"
          x1={10.7717}
          y1={15.611}
          x2={28.8684}
          y2={24.05}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#fff" stopOpacity={0.2} />
          <Stop offset={1} stopColor="#fff" stopOpacity={0} />
        </LinearGradient>
      </Defs>
    </Svg>
  );
}

export default SvgComponent;
